import { useTranslation } from "react-i18next";
import DdiElement from "./DdiElement";
import {Consts} from "../pages/consts";
import {buildDdiProduct} from "./utils";

const DdiInfo = ({ showInfo, setShowInfo, drug }) => {
  const { t } = useTranslation();

  const capitalizeFirstLetter = (compound) => {
    return compound?.charAt(0)?.toUpperCase() + compound?.slice(1);
  }

  const newDdis = drug?.ddis?.map(ddi => {
    const newFocusDrug = {...ddi?.focusDrug, compound: capitalizeFirstLetter(ddi?.focusDrug?.compound)};
    const newDdiDrug = {...ddi?.ddiDrug, compound: capitalizeFirstLetter(ddi?.ddiDrug?.compound)};
    return {...ddi, focusDrug: newFocusDrug, ddiDrug: newDdiDrug};
  });

  const newDrug = {...drug, ddis: newDdis};

  const focusProduct = drug?.productName === Consts.NOT_SPECIFIED || drug?.productName === Consts.ANY
    ? t(Consts.NOT_SPECIFIED).toLowerCase()
    : drug?.productName;

  return (
    <div className="w3-modal" style={{ display: showInfo ? Consts.BLOCK : Consts.NONE }}>
      <div className="w3-modal-content w3-animate-zoom ddi-dgi-panel dialog-medium">
        <div className="w3-container dialog-content-scroll">
          {newDrug?.ddis?.length > 0 && (
            <div>
              {newDrug?.ddis?.map ((ddi, n) => {
                return (
                  <div key={`newDrugDdi${n}`}>
                  <div className="w3-row">
                    <label className="bold-label w3-margin-top">
                      {n + 1} {". "}{ddi?.focusDrug?.compound} {t("containing_in_your_medicine")}
                      {" "}{focusProduct}{" "}
                      {t("has_drug_drug_interactions_with")?.toLowerCase()}
                    </label>
                  </div>
                  <DdiElement
                    ddi={ddi}
                    productName={buildDdiProduct(ddi?.ddiDrug, t("not_specified"))}
                    key={`ddi${n}`}
                  />
                  </div>
                )}
              )}
            </div>
          )}
          <div className="w3-row w3-left-align">
            <a
              href="https://abdata.de/produkte/abdadatenbank2/"
              target="_blank"
              rel="noopener noreferrer"
              className="w3-text-green"
            >
              {t("ddi_source")}
            </a>
          </div>
          {drug?.ddis?.length > 0 && (
            <div className="w3-row w3-padding-small">
              <label className="notice-text">
                ⚠️ {t("always_discuss_with_hcp_notice")}
              </label>
            </div>
          )}
        </div>
        <footer className="w3-container w3-padding-small">
          <p className="w3-right">
            <label
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-margin-left"
              onClick={() => setShowInfo(false)}
            >
              {t("close")}
            </label>
          </p>
        </footer>
      </div>
    </div>
  );
};

export default DdiInfo;
